export enum TaxRateMode {
  AUTO = 'Automated tax rate',
  MANUAL = 'Manual tax rate',
}
